'use client'

import { autoFetch } from '@homeSearch/modules/fetch'
import HomeSearchInput from '@homeSearch/modules/input'
import Location from '@homeSearch/modules/location'
import HomeSearchPopup from '@homeSearch/modules/popup'
import useProgressRouter from '@hooks/useProgressRouter'
import IconLocation from '@icon/const/location.svg'
import { searchResultDataLayer } from '@plugin/google/gtm/modules/houseList'
import { houseList } from '@router'
import { Suspense, useCallback, useMemo } from 'react'
import { getSlugData } from '../../utils'
import useHouseSearchContext from '../context'
import { houseSearchType } from '@routerConfig'
import { isEqual, map, size } from 'lodash-es'

export default function SearchInputContent({
  onFocus,
  className = ''
}) {

  const { replaceRouter } = useProgressRouter()
  const { state } = useHouseSearchContext()
  const { type } = state

  const placeholders = useMemo(() => {
    if (type === houseSearchType.retirementLiving) {
      return ['Type a region, city, or village name', 'Type a region, city, or village name']
    }
    return []
  }, [type])

  const searchHandle = useCallback(({ suburbs, surrounding }) => {
    if (!size(suburbs)) return

    /**
     * 判断suburbs是否和state.suburbs一致
     * 并且surrounding是否和state.surround一致
     * 如果一致则不触发搜索
     */
    if (
      isEqual(map(suburbs, 'id'), map(state.suburbs, 'id'))
      && state.surround === surrounding
    ) {
      return
    }

    const { slug, type } = state
    const houseRoute = getSlugData(slug)
    houseRoute.clearSuburbs().setSuburbs(suburbs)
    houseRoute.pushNewZealand()
    houseRoute.surround = surrounding
    houseRoute.page = 1
    const newSlug = houseRoute.toSlug()
    if (newSlug === slug) return
    const route = houseList(type, newSlug)
    searchResultDataLayer.searchButtonClick(type)
    replaceRouter(route)
  }, [replaceRouter, state])

  const fetcher = useCallback((keyword) => {
    return autoFetch(keyword, type)
  }, [type])

  return (
    <Suspense>
      <HomeSearchInput
        onSearch={searchHandle}
        onFocus={onFocus}
        searchIcon={false}
        showSearchButton={false}
        placeholder={placeholders[0]}
        mobilePlaceholder={placeholders[1]}
        prefixIcon={<IconLocation className='ml-10' width={20} height={20}></IconLocation>}
        className={className}
      >
        <HomeSearchPopup fetcher={fetcher}></HomeSearchPopup>
      </HomeSearchInput>
      <Location></Location>
    </Suspense>
  )
}
